import React, { useState, useEffect } from "react"; 
import { useStaticQuery, graphql } from "gatsby";
import MaintenanceForm from "@Components/forms/maintenance-form"
import ReactMarkdown from "react-markdown"
import "./MaintenanceReporting.scss";
import { Container, Row, Col } from "react-bootstrap";
import { inViewOptions } from '../../Components/utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const titleVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    delay: 0.4,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}

const contentVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    delay: 1,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}

const MaintenanceReporting = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const data = useStaticQuery(graphql`
    query {
      glstrapi {
        globalConfig(publicationState: LIVE) {
          id
          imagetransforms
          ggfx_results {
            id
            content_type
            transforms
            src_import_url
            src_cftle
            field
          }
          Contact_Image {
            url
          }
          Contact_Description
          Contact_Title
        }
      }
    }
  `);

  return (
    <InView {...inViewOptions}>
      {({ ref, inView }) => {
        return (
          <motion.section
            ref={ref}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={containerVariants}
            className="section-maintenance-reporting"
          >
            <React.Fragment> 
              <Container className="py-5">
                <Row>
                  <Col lg={8} md={10} xs={12}>
                    <div className="maintenance-container p-3 p-md-4">
                      <motion.div variants={titleVariants} className="mb-5 text-left">
                        <p>For all non-emergency issues, please complete the form and a member of our Property Management team will be in touch.</p>
                        <h2 className="mb-4 font-weight-bold">Maintenance Reporting</h2>  
                      </motion.div>

                      <motion.div variants={contentVariants}>
                        <MaintenanceForm to_email_id={props.to_email_id || ""} />
                      </motion.div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </React.Fragment>
          </motion.section>
        );
      }}
    </InView>
  );
}

export default MaintenanceReporting;
